<form [formGroup]="form" class="offers-editor">
  @if (!isPreviewMode) {
    <div class="offers-editor__grid">
      <div class="offers-editor__field offers-editor__field--full">
        <label class="offers-editor__label" for="offerName">
          {{ 'shop-settings.content.offers-editor.name' | translate }} *
        </label>
        <input id="offerName" class="offers-editor__input" type="text" formControlName="name" />
      </div>

      <div class="offers-editor__field offers-editor__field--full">
        <label class="offers-editor__label" for="offerSelectionType">
          {{ 'shop-settings.content.offers-editor.selection-type' | translate }}
        </label>
        <select
          id="offerSelectionType"
          class="offers-editor__select"
          formControlName="selectionType"
        >
          <option [value]="1">
            {{ 'shop-settings.content.offers-editor.static-list' | translate }}
          </option>
        </select>
      </div>

      <div class="offers-editor__field offers-editor__field--full">
        <label class="offers-editor__label" for="offerSearchQuery">
          {{ 'shop-settings.content.offers-editor.search' | translate }}
        </label>
        <div class="offers-editor__search-row">
          <input
            id="offerSearchQuery"
            class="offers-editor__input"
            type="text"
            formControlName="searchQuery"
          />
          <button type="button" class="offers-editor__add-btn" (click)="addManualProduct()">
            {{ 'shop-settings.content.offers-editor.add-product' | translate }}
          </button>
        </div>
      </div>

      <div class="offers-editor__field offers-editor__field--full">
        <span class="offers-editor__label">
          {{ 'shop-settings.content.offers-editor.selected-products' | translate }}
        </span>

        @if (selectedProducts().length > 0) {
          <div class="offers-editor__table">
            @for (product of selectedProducts(); track product.id) {
              <div class="offers-editor__table-row">
                <div class="offers-editor__table-name">{{ product.name }}</div>
                <button
                  type="button"
                  class="offers-editor__remove-btn"
                  (click)="removeProduct(product.id)"
                >
                  {{ 'shop-settings.content.offers-editor.remove' | translate }}
                </button>
              </div>
            }
          </div>
        } @else {
          <div class="offers-editor__empty">
            {{ 'shop-settings.content.offers-editor.empty-list' | translate }}
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="offers-editor__preview">
      <h3 class="offers-editor__preview-title">
        {{
          form.controls.name.value ||
            ('shop-settings.content.offers-editor.preview-title' | translate)
        }}
      </h3>

      <div class="offers-editor__preview-list">
        @for (product of selectedProducts(); track product.id) {
          <div class="offers-editor__preview-card">{{ product.name }}</div>
        }
      </div>
    </div>
  }
</form>
